import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { WebapiService } from '../webapi.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PreloaderService } from '../preloader.service';

@Component({
  selector: 'app-client',
  templateUrl: './client.component.html',
  styleUrls: ['./client.component.scss']
})
export class ClientComponent implements OnInit {

  checkList: any;
  formData: any = {};
  proData: any = {};
  insData: any = {};
  checkArr: any = [];
  updateCheckArr: any = [];
  insertCheckArr: any = [];
  clientList: any;
  clientId: any;
  processArr: any = [];
  proCounter: boolean = false;
  clientImgsrc: any;
  someSubscription: any;
  isActive: boolean = true;
  checkListt: any;
  processData: any = {};
  checkListv2: any=[];
  constructor(private WebApiService: WebapiService, private activatedRoute: ActivatedRoute,
    private router: Router, private modalService: NgbModal, private spinner: PreloaderService) {
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    };
    this.someSubscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        // Here is the dashing line comes in the picture.
        // You need to tell the router that, you didn't visit or load the page previously, so mark the navigated flag to false as below.
        this.router.navigated = false;
      }
    });
  }

  ngOnInit(): void {

    this.clientId = this.activatedRoute.snapshot.paramMap.get("id");
    this.getAllCheck();
    this.getAllChecksv2();
    this.getClient();
    if (this.clientId) {
      this.proCounter = true;
      this.getClientById(this.clientId);
    }
    this.formData.processList = [{
      'process': '',
      'checkList': this.checkList
    }];
  }

  ngOnDestroy() {
    if (this.someSubscription) {
      this.someSubscription.unsubscribe();
    }
  }

  closeModal() {
    location.reload();
  }
  updateProcess(data: any) {
    data._id = this.clientId;

    if (data?.checkList?.length > 0) {
      data.checkList = data.checkList.filter((e: any) => {
        return e.selected === true;
      })
    }

    let newObj = {
      process: data.process,
      altprocess: data.altprocess,
      checkList: data.checkList,
      processPrice: data.processPrice
    }
    data.processList[data.indexToUpdate] = newObj;

    this.WebApiService.insertUser(data).subscribe((res: any) => {
      console.log(res);
      if (res.status == "ok") {
        alert(res.msg);
        this.modalService.dismissAll();
      }
      else {
        alert(res.msg);
      }

    });

  }

  getProcessChecksByName(e: any) {
    let val = {
      processName: e.target.value
    }
    // this.WebApiService.getProcessChecksByName(val).subscribe((res:any)=>{
    //   console.log(res);
    //    if(res.length >0){
    //      alert('processName Already Exist');
    //      e.target.value = '';
    //    }
    // });

  }

  insertProcess(data: any) {
    data._id = this.clientId;
    if (data?.checkList?.length > 0) {
      data.checkList = data.checkList.filter((e: any) => {
        return e.selected === true;
      })
    }
    let newObj = {
      process: data.process,
      altprocess: data.altprocess,
      checkList: data.checkList,
      processPrice: data.processPrice
    }
    data.processList.push(newObj);

    this.WebApiService.insertUser(data).subscribe((res: any) => {
      if (res.status == "ok") {
        alert(res.msg);
        this.modalService.dismissAll();
      }
      else {
        alert(res.msg);
      }
    });

  }

  getInsertChecks(e: any) {
    if (e.target.checked == true) {
      this.insertCheckArr.push(e.target.value);
    } else {
      var index = this.insertCheckArr.indexOf(e.target.value);
      this.insertCheckArr.splice(index, 1);
    }
    this.insData.checks = JSON.stringify(this.insertCheckArr);
  }

  getUpdateChecks(e: any) {
    if (e.target.checked == true) {
      this.updateCheckArr.push(e.target.value);
    } else {
      var index = this.updateCheckArr.indexOf(e.target.value);
      this.updateCheckArr.splice(index, 1);
    }
    console.log(this.updateCheckArr);
    this.proData.checks = JSON.stringify(this.updateCheckArr);
  }
  getChecksArr(e: any, i: any) {

    if (e.target.checked == true) {
      this.checkArr.push(e.target.value);
    } else {
      var index = this.checkArr.indexOf(e.target.value);
      this.checkArr.splice(index, 1);
    }
    console.log(this.checkArr);
    this.formData.processList[i].checks = JSON.stringify(this.checkArr);
  }

  checkThis(id) {
    if (this.updateCheckArr.length > 0) {
      let exist = this.updateCheckArr.filter(x => x == id);
      return exist.length > 0;
    } else {
      return false;
    }
  }

  deleteClient(id: any) {
    let val = confirm("Are you sure you want to delete");
    if (val) {
      let data = {
        _id: id,
        isActive: false
      }
      this.WebApiService.deleteUser(data).subscribe((res: any) => {
        if (res.status == "ok") {
          alert(res.msg);
          this.router.navigate(['/client'])
        }
        else {
          alert('Something went wrong');
        }
      })
    }
  }


  // addProcess() {
  //  let length = this.formData.processList.length

  //   for(let check of this.checkList){
  //     delete check['selected'];
  //     check['selected'+length] = false
  //   }


  //   this.formData.processList.push(
  //     {
  //       'process':'',

  //     }
  //   );
  //   console.log( this.formData.processList[length],'------------------',length);

  //   this.formData.processList[length]['option'] = this.checkList
  //   this.formData.processList[length]['process'] = ''
  //   console.log(this.formData.processList);
  // }

  addProcess1() {
    this.WebApiService.getAllCheck().subscribe((res: any) => {
      this.checkListt = res.setting;
      for (let f of this.checkListt) {
        f.selected = false;
      }
      this.formData.processList.push({
        'checkList': this.checkListt
      });
    });

  }

  getAllChecksv2(){
    this.WebApiService.getAllCheck().subscribe((res: any) => {
      this.checkListv2 = res.setting;
      for (let f of this.checkListv2) {
        f.selected = false;
      }
    });

  }

  //new code from Ayush

  getLogo(e: any) {
    this.spinner.show();
    if (e.target.files) {
      // this.formData.img = e.target.files[0];
      const file = e.target.files[0];
      const reader = new FileReader();
      reader.onload = e => this.clientImgsrc = reader.result;
      reader.readAsDataURL(file);
      const formData = new FormData();
      formData.append('image', e.target.files[0]);
      formData.append('type', 'return');
      this.WebApiService.uploadImage(formData).subscribe((res: any) => {
        if (res.status == "ok") {
          alert('upload success');
          this.formData.img = res.imageName
          this.spinner.hide();

        }
        else {
          alert("something went wrong");
          this.spinner.hide();
        }
      });
    }
    else {
      console.log('no file selected');
      this.spinner.hide();
    }
  }

  removePreview(e: any) {
    this.clientImgsrc = '';
    e.value = '';
  }

  getAllCheck() {
    this.WebApiService.getAllCheck().subscribe((res: any) => {
      this.checkList = res.setting;
      for (let f of this.checkList) {
        f.selected = false;
      }
      if (!this.clientId) {
        this.formData.processList[0].checkList = res.setting;
      }
    });
  }

  insertClient(data: any) {
    if (this.clientId) {
      data._id = this.clientId;
    }
    data.type = 3;
    data.isActive = true;
    let filterCheck = data.processList[0].checkList.filter((e: any) => e.selected == true);
    data.processList[0].checkList = filterCheck;
    this.WebApiService.insertUser(data).subscribe((res: any) => {

      if (res.status == "ok") {
        alert(res.msg);
        location.reload();
      }
      else {
        alert("something went wrong");
      }
    });

  }


  getClient() {
    this.WebApiService.getAllClient().subscribe((res: any) => {
      this.clientList = res.user;
    });
  }

  getClientById(id: any) {
    this.WebApiService.getUserById(id).subscribe((res: any) => {
      this.formData = res.user;
    });
  }

  deleteProcess(data: any, arr: any) {
    let prompt = confirm("Are you sure you want to delete");
    if (prompt) {
      data._id = this.clientId;
      let index = arr.findIndex(x => x.process == data.process);
      arr.splice(index, 1);
      data.processList = arr;
      this.WebApiService.insertUser(data).subscribe((res: any) => {
        if (res.status == "ok") {
          alert(res.msg);
        }
        else {
          alert(res.msg);
        }

      });
    }
    else {
        console.log('Canceled By User');

    }

  }

  openModal(exampleModalContent, data: any, arr: any, i: any) {    
    this.modalService.open(exampleModalContent, { size: 'sm' });
    // if (data) {
    //   this.proData.process = data.process;
    //   this.proData.processPrice = data.processPrice;
    //   this.proData.altprocess = data.altprocess;
    //   this.proData.indexToUpdate = i;
    //   this.proData.processList = arr;
  
    //   // Prepare checklist with selected keys
    //   const selectedIds = data.checkList?.map(item => item._id) || [];
  
    //   this.proData.checkList = this.checkListv2.map(item => {
    //     return {
    //       ...item,
    //       selected: selectedIds.includes(item._id)
    //     };
    //   });
      
    // }
    if (data) {
      this.proData.process = data.process;
      this.proData.processPrice = data.processPrice;
      this.proData.altprocess = data.altprocess;
      this.proData.indexToUpdate = i;
      this.proData.processList = arr;
    
      // Prepare checklist with selected keys and prices
      const selectedList = data.checkList || [];
    
      this.proData.checkList = this.checkListv2.map(item => {
        const selectedItem = selectedList.find(sel => sel._id === item._id);
        return {
          ...item,
          selected: !!selectedItem, // true if exists
          checkPrice: selectedItem ? selectedItem.checkPrice : '' // set price if selected
        };
      });
    }
  }
  addProcessModal(exampleModalContent, data: any) {
    this.modalService.open(exampleModalContent, { size: 'sm' });
    if (data) {
      this.insData.checkList = this.checkList
      this.insData.processList = data;
    }
  }


}
